import {
  AIR_HUMIDITY,
  AIR_TEMPERATURE,
  ET0,
  SOIL_MOISTURE_ALL_DEPTHS,
  VALVE_STATE,
  WATER_PRESSURE,
} from '../hooks/graph';

export const DEFAULT_SOIL_CHARTS = [
  SOIL_MOISTURE_ALL_DEPTHS,
  WATER_PRESSURE,
  VALVE_STATE,
];

export const DEFAULT_WEATHER_CHARTS = [ET0, AIR_TEMPERATURE, AIR_HUMIDITY];

export const getDefaultPresetCharts = (preset) => {
  if (preset === 'soil') return DEFAULT_SOIL_CHARTS;
  if (preset === 'weather') return DEFAULT_WEATHER_CHARTS;
  return [];
};
